import Button from '@material-ui/core/Button';
import styled from 'styled-components/macro';

import { Container } from '../../styled';

const FallbackLoginButton = () => {
    return (
        <Container>
            <StyledButton variant='outlined' color='primary' onClick={undefined}>
                Effettua l'accesso
            </StyledButton>
        </Container>
    );
};

const StyledButton = styled(Button)`
    width: 100%;
    margin: 4px 0;
`;

export default FallbackLoginButton;
